import { Box, CircularProgress } from "@mui/material"
import Grid from "@mui/material/Unstable_Grid2/Grid2"
import EntregaAguardandoRecebimento from "./EntregaAguardandoRecebimento/EntregaAguardandoRecebimento"
import { useContext } from "react"
import { EncomendaContex } from "../../../../Providers/EncomendaContext/EncomendaContext"
import { useAppTheme } from "../../../../Providers/ThemeContext/ThemeContext"

const ListaAguardandoEntregas = () => {
    const { theme } = useAppTheme()
    const { resultEntregasFuturas, loading } = useContext(EncomendaContex)

    return (
        <Box>

            {
                loading
                    ? <Grid sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <CircularProgress size={50} sx={{ color: theme.palette.one_primary.main }} />
                    </Grid>
                    : (
                        resultEntregasFuturas.length > 0 &&
                                resultEntregasFuturas.map((dado, index) => {
                                    return <EntregaAguardandoRecebimento key={index} result={dado} />
                                })
                    )
            }

        </Box>
    )
}

export default ListaAguardandoEntregas
